import Cookies from 'js-cookie';

import { APP_VERSION_FULL } from '../version.ts';

const getOptimizeCookie = () => {
  const optimizeCookie = Cookies.get('SCOOPR_OPTIMIZE_EXP');
  if (!optimizeCookie) {
    return {};
  }

  const relevantPart = optimizeCookie.substring(2);
  const keyValuePairs = relevantPart.split(',');

  const result = Object.fromEntries(keyValuePairs.map((pair) => pair.split('.')));

  return {
    experiments_data: JSON.stringify(result),
  };
};

const globalParams: Record<string, unknown> = {};

export const setGlobalAnalyticsParam = (key: string, value: string) => {
  globalParams[key] = value;
};

export const deleteGlobalAnalyticsParam = (key: string) => {
  delete globalParams[key];
};

export const getGlobalAnalyticsParams = (): Record<string, unknown> => {
  return {
    ...globalParams,
    ...getOptimizeCookie(),
    pseudo_user_id: Cookies.get('_ga')?.replace('GA1.1.', '') || globalParams.pseudo_user_id,
    app_version: APP_VERSION_FULL,
    page_path: window.location.pathname,
  };
};
